/*global _*/
// @flow
import {UniAfDetailViewCtrl} from 'uni-framework';
import Constantes from '../../constant';
import windowEtiquetasTemplate from './window.etiquetas.html';
import labelJSON from '../../res/defaultLabel';
import Label from '../../js/label';
import fs from 'fs';
import Helvetica from '!!raw-loader!pdfkit/js/data/Helvetica.afm';

fs.writeFileSync('data/Helvetica.afm', Helvetica);

class EtiquetasDetailViewCtrl extends UniAfDetailViewCtrl {

	constructor() {
		///////////////////////////////////////////////////////////////////////////////////////////////////////////////
		//Unicorp Framework - Codigo base de inicialização do controller, não alterar!!
		let injectHelper = _.object(EtiquetasDetailViewCtrl.$inject, arguments);
		super(injectHelper, {viewName: 'EtiquetasDetailView'});
		Object.assign(this, injectHelper);
		///////////////////////////////////////////////////////////////////////////////////////////////////////////////

		//Default State
		const defaultHelper = {
			headerOptions: {
				hideControllers: true
			},
			qrCodeOptions: {
				size: 60
			}
		};
		Object.assign(this, defaultHelper);

		this.AddAction({
			type: 'button',
			click: this.addEtiqueta.bind(this),
			icon: 'k-icon k-i-file-add',
			text: this.$translate.instant('NEW'),
			overflow: 'never'
		});

		this.AddAction({
			type: 'button',
			click: this.openWindowEtiquetasLote.bind(this),
			icon: 'k-icon k-i-folder-add',
			text: this.$translate.instant('EDIT_LOTE'),
			overflow: 'never'
		});

		this.AddAction({
			type: 'separator',
			overflow: 'never'
		});

		this.AddAction({
			type: 'button',
			click: this.printerEtiquetas.bind(this),
			icon: 'k-icon k-i-print',
			text: this.$translate.instant('PRINT_LABELS'),
			overflow: 'never'
		});

		this.etiquetas = [];
		this.etiquetasLote = Constantes.EMPTY_STRING;
	}

	getLasIndex(): number {
		const self = this;
		return self.etiquetas.length - Constantes.ARRAY_ONE_INDEX;
	}

	addEtiqueta(): any {
		const self = this;
		self.etiquetas.push(Constantes.EMPTY_STRING);
		setTimeout((): any => document.getElementById(`etiqueta_${self.getLasIndex()}`).focus(), 0);
		self.uniUtil.applyScope(self.$scope);
	}

	async openWindowEtiquetasLote(): any {
		const self = this;
		let result = await self.UniWindowService.openWindow({
			options: {
				modal: true,
				title: this.$translate.instant('ETIQUETAS'),
				width: 400,
				visible: false
			},
			controller: 'EtiquetasDetailViewCtrl',
			controllerAs: 'operacao',
			template: windowEtiquetasTemplate,
		});
		self.etiquetas = result;
		self.uniUtil.applyScope(self.$scope);
	}

	addWhenLastAndPressEnter(index: number, $event: any): any {
		const self = this;
		let lastIndex = self.getLasIndex();
		if (_.isEqual(lastIndex, index) && _.isEqual($event.keyCode, Constantes.KEY_CODE_ENTER)) {
			$event.preventDefault();
			self.addEtiqueta();
		}
	}

	addEtiquetasLote(): any {
		const self = this;
		let etiquetas = self.etiquetasLote.split('\n');
		self.$scope.$close(etiquetas);
	}

	deleteEtiqueta(index: number): any {
		const self = this;
		self.etiquetas.splice(index, Constantes.ARRAY_ONE_INDEX);
	}

	getParamsLabelPrint(): Object {
		const self = this;
		let params = {
			'labels': []
		};
		_.each(self.etiquetas, (etiqueta: string): any => {
			params.labels.push({'description': etiqueta});
		});
		return params;
	}

	haveEmptyEtiquetas(): boolean {
		const self = this;
		return _.contains(self.etiquetas, Constantes.EMPTY_STRING);
	}

	uint8ToString(u8a: any): any {
		var CHUNK_SZ = 0x8000;
		var c = [];
		for (var i = 0; i < u8a.length; i += CHUNK_SZ) {
			c.push(String.fromCharCode.apply(null, u8a.subarray(i, i + CHUNK_SZ)));
		}
		return c.join('');
	}

	async printerEtiquetas(): Promise<any> {
		const self = this;

		let label = new Label(labelJSON);
		let pdfData = await label.getPDF(self.etiquetas);

		var b64encoded = btoa(self.uint8ToString(pdfData));

		self.uniPDFViewerService.show({
			pdf: {
				name: 'Etiquetas.pdf',
				data: b64encoded
			}
		});
	}

}

EtiquetasDetailViewCtrl.$inject = _.union(UniAfDetailViewCtrl.GetDefaultInjections(), ['UniWindowService', 'uniPDFViewerService']);
export default EtiquetasDetailViewCtrl;
